import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getAllByPaciente = async ( idPaciente ) => {

  if( !idPaciente ) {
    console.error("No se envio el id del paciente");
    return null;
  }

  const query = `
    query MyQuery($idpaciente : ID) {
      getAntfamanamIdpaciente(idpaciente: $idpaciente) {
        message
        status
        afamiliares {
          id
          familiar
          token
          estado
          descripcionGeneral
          antescedentesFamiliares {
            id
            descripcion
            tipoAntecedente
          }
          consultamedica {
            id
            cita {
              fechaCita
              id
              paciente { id }
            }
          }
        }
      }
    }
  `;

  const variables = {
    idpaciente: idPaciente
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if( response.status !== 200) return null;

    const response2 = response.data.data.getAntfamanamIdpaciente;
    if( response2.status !== 'success' ) return null;

    const data = response2.afamiliares;
    return data;

    console.log('response ant familiar', response);
  } catch (error) {
    console.error("Error fetching antecedentes familiares:", error.response.data);
    return null;
  }
}


export const antFamiliaresService = {

  getAllByPaciente
}